import apiRequest, { APIError } from './apiRequest';
import {
  mapExternalCharacterItemToCharacter,
  type ExternalCharacterItem,
} from './getExternalCharacters';

type ExternalCharacterResponse =
  | ExternalCharacterItem
  | { character?: ExternalCharacterItem | null };

export default async function getExternalCharacter(
  apiKey: string,
  characterID: string,
) {
  const response = await apiRequest<ExternalCharacterResponse>(
    'external-mogen',
    `/characters/${encodeURIComponent(characterID)}`,
    {
      method: 'GET',
      headers: {
        'x-api-key': apiKey,
      },
    },
  );

  if (response.error) {
    return { error: response.error };
  }

  const item = getExternalCharacterResponseItem(response.data);
  const character = item
    ? mapExternalCharacterItemToCharacter({
        ...item,
        characterID: item.characterID ?? characterID,
        objectID: item.objectID ?? item.characterID ?? characterID,
        jobID: item.jobID ?? item.characterID ?? item.objectID ?? characterID,
      })
    : null;

  if (!character) {
    return {
      error: new APIError('Failed to load character.', 500),
    };
  }

  return { data: character };
}

function getExternalCharacterResponseItem(
  data?: ExternalCharacterResponse,
): ExternalCharacterItem | null {
  if (!data) {
    return null;
  }

  if (isWrappedExternalCharacterResponse(data)) {
    return data.character ?? null;
  }

  return data;
}

function isWrappedExternalCharacterResponse(
  data: ExternalCharacterResponse,
): data is { character?: ExternalCharacterItem | null } {
  return Object.prototype.hasOwnProperty.call(data, 'character');
}
